var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatlineBtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 129,
    viewBox: "0 0 182 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135.576,
    y: 196.164,
    width: 41,
    height: 116,
    transform: "rotate(-135 135.576 196.164)",
    fill: "#DAE3EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.499,
    y: 200.242,
    width: 20.8189,
    height: 174.38,
    transform: "rotate(-135 74.499 200.242)",
    fill: "#F8F9FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.873,
    y: 183.868,
    width: 32.115,
    height: 192.236,
    transform: "rotate(-135 61.873 183.868)",
    fill: "#F1F3F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5762,
    y: 196.164,
    width: 29.0998,
    height: 248.318,
    transform: "rotate(-135 20.5762 196.164)",
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlineBtm);
export default __webpack_public_path__ + "static/media/chatlineBtm.58eca4ab02cf8b4943a416e56bffdf10.svg";
export { ForwardRef as ReactComponent };